export default __webpack_public_path__ + "static/media/antarctic-and-southern-ocean-coalition-charity.6e60873c.jpeg";